<div class="prose">
  <div class="flex justify-center">
    <img class="h-16" src="assets/images/EscrowTabLogo.svg" />
  </div>
  <h1 class="px-3 py-3 font-light text-secondary">
    Failed to login, please try again later.
  </h1>
</div>
